import BaseService from '@/utils/base-service';
import {ApiResponse} from '@/models';
import {FileDownload} from '@/models/file-download';
import {PrRecommendationsBulkUpdateResult} from '@/models/pr-recommendations-bulk-update-result';

export class PrRecommendationsService extends BaseService {
    private endpoint = '/DataManagement';

    constructor() {
        super(process.env.VUE_APP_API_BASE_URL);
    }

    public async downloadTemplate(): Promise<FileDownload> {
        const response = (await this.api.get(`${this.endpoint}/PrRecommendationsXlsxTemplate`,
            {
                responseType: 'arraybuffer',
            }));

        return FileDownload.fromResponse(response, 'bulk-update-template.xlsx');
    }

    public async bulkUpdate(file: File, dryRun = false): Promise<ApiResponse<PrRecommendationsBulkUpdateResult>> {
        const formData = new FormData();
        formData.append('file', file);
        return (await this.api.post(`${this.endpoint}/PrRecommendationsUpdate?dryRun=${dryRun}`,
            formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })).data;
    }
}
